import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import trialBalanceTemplate from './trialBalance.template.html';

export default angular
  .module('books.ui.trialBalance', [csmCommonWeb, booksService])
  .directive('trialBalance', trialBalanceDirective).name;

/* @ngInject */
function trialBalanceDirective(BooksSvc, BusyScreen) {
  return {
    template: trialBalanceTemplate,
    scope: {
      acctSin: '@', // Label for type of report in singular format
      acctPl: '@', // Label for type of report in plural format
      reportByHide: '@', // Hides the "report by" div when true.
      sortByHide: '@' // Hides the "sort by" div when true.
    },
    link: function ($scope, element, attr) {
      var mGroups = [];
      var mAllOption = { id: 0, description: 'All Groups' };

      /*---------------------------------------------------------*/
      /* Sets the defaults of the report to be pulled by account */
      /* and account name and puts the report in PDF format.     */
      /*---------------------------------------------------------*/
      $scope.req = {
        groupAccts: false,
        order: 'NAME',
        reportFormat: 'PDF'
      };
      $scope.data = {};

      /***********************************************************************
       * reportByAccount */
      /**
       * Sets the report to be pulled by the account, checks that the groupID is 0
       * and sets the reportByGroups to false.
       ***********************************************************************/
      $scope.reportByAccount = function () {
        $scope.req.groupAccts = false;
        $scope.req.groupID = 0;
        $scope.req.reportByGroups = false;
      };

      /***********************************************************************
       * reportByGroup */
      /**
       * Sets the report to be pulled by the group and allows the selection of which
       * group can be pulled and sets the report to be pulled by groups.
       ***********************************************************************/
      $scope.reportByGroup = function () {
        $scope.req.groupAccts = true;
        $scope.req.reportByGroups = true;
      };

      /*------------------------------------------*/
      /* Uses the validator directive to validate */
      /* there is a date in the date field.       */
      /*------------------------------------------*/
      $scope.valDate = {};
      $scope.validateInput = function () {
        return $scope.valDate.validate();
      };

      /*-------------------------------------------------*/
      /* Watches the data.group and sets the groupID to  */
      /* 0 (all groups) if an invalid selection was made */
      /*-------------------------------------------------*/
      $scope.$watch('data.group', function (group) {
        var groupSelected = group && angular.isObject(group);
        $scope.req.groupID = groupSelected ? group.id : 0;
      });

      /*--------------------------------------------------------*/
      /* Adds the mAllOption to the top of the groups typeahead */
      /*--------------------------------------------------------*/
      $scope.getGroups = function (text) {
        return [mAllOption].concat(
          mGroups.filter(function (g) {
            return g.description.toLowerCase().indexOf(text.toLowerCase()) >= 0;
          })
        );
      };

      /*--------------*/
      /* Get services */
      /*--------------*/
      BooksSvc.getAccountGroups().then(function (resp) {
        mGroups = resp.data.sort(function (a, b) {
          return a.description
            .toLowerCase()
            .localeCompare(b.description.toLowerCase());
        });

        BooksSvc.getOrganization().then(function (resp) {
          $scope.org = resp.data;
        });
        BusyScreen.setBusy(false);
      });
    }
  };
}
